const initialState = {
    levelThreeList: [],
    isFetchingLevelThree: false,
    isAddingLevelThree: false,
    isFetchingLevelThreeWithLevelTwoId: false,
    levelThreeWithLevelTwoIdList: [],
    isUploadingLevelThree: false,
    uploadlevelThree: [],
};

const LevelThreeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_ADD_LEVELTHREE":
            return { ...state, isAddingLevelThree: true };
        case "SUCCESS_ADD_LEVELTHREE":
            return { ...state, levelThreeList: action.payload, isAddingLevelThree: false };
        case "ERROR_ADD_LEVELTHREE":
            return { ...state };


        case "REQUEST_GET_LEVELTHREE":
            return { ...state, isFetchingLevelThree: true };
        case "SUCCESS_GET_LEVELTHREE":
            return { ...state, levelTwoList: action.payload, isFetchingLevelThree: false };
        case "ERROR_GET_LEVELTHREE":
            return { ...state, isFetchingLevelThree: false };


        case "REQUEST_GET_LEVELTHREE_WITH_LEVELTWO_ID":
            return { ...state, isFetchingLevelThreeWithLevelTwoId: true };
        case "SUCCESS_GET_LEVELTHREE_WITH_LEVELTWO_ID":
            return { ...state, levelThreeWithLevelTwoIdList: action.payload, isFetchingLevelThreeWithLevelTwoId: false };
        case "ERROR_GET_LEVELTHREE_WITH_LEVELTWO_ID":
            return { ...state, isFetchingLevelThreeWithLevelTwoId: false };


        case "REQUEST_UPLOAD_LEVELFTHREE_FILE":
            return { ...state, isUploadingLevelThree: true };
        case "SUCCESS_UPLOAD_LEVELFTHREE_FILE":
            return { ...state, uploadlevelThree: action.payload, isUploadingLevelThree: false };
        case "ERROR_UPLOAD_LEVELTHREE_FILE":
            return { ...state };


        default:
            return state;
    }
};
export default LevelThreeReducer;